export function toLocalDateString(date) {
  if (!date) return null;
  const d = date instanceof Date ? date : new Date(date);
  return d.toLocaleDateString("en-CA");
}

export function todayString() {
  return new Date().toLocaleDateString("en-CA");
}

export function isToday(date) {
  if (!date) return false;
  return toLocalDateString(date) === todayString();
}

export function isPast(date) {
  if (!date) return false;
  return toLocalDateString(date) < todayString();
}

export function isFuture(date) {
  if (!date) return false;
  return toLocalDateString(date) > todayString();
}

export function hasNotStartedYet(startDate) {
  if (!startDate) return false;
  return isFuture(startDate);
}

export function toLocalTimeString(dateTimeStr) {
  if (!dateTimeStr) return "";
  const d = new Date(dateTimeStr);
  return `${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
}

export function toLocalTimeDisplay(dateTimeStr) {
  if (!dateTimeStr) return "";
  const d = new Date(dateTimeStr);
  const h = d.getHours();
  const m = d.getMinutes();
  const period = h >= 12 ? "PM" : "AM";
  const displayH = h > 12 ? h - 12 : h == 0 ? 12 : h;
  return `${displayH}:${String(m).padStart(2, "0")} ${period}`;
}

export function formatDisplayDate(date, options = {}) {
  if (!date) return "—";
  const d = date instanceof Date ? date : new Date(date);
  return d.toLocaleDateString("en-IN", {
    day: "numeric",
    month: "short",
    year: "numeric",
    // hour: "numeric",
    // minute: "2-digit",
    ...options,
  });
}

export function toInputDateValue(date) {
  if (!date) return "";
  const d = date instanceof Date ? date : new Date(date);
  return d.toLocaleDateString("en-CA");
}

export function parseLocalDate(dateStr) {
  if (!dateStr) return null;
  const str =
    typeof dateStr === "string"
      ? dateStr.split("T")[0]
      : new Date(dateStr).toLocaleDateString("en-CA");
  const [year, month, day] = str.split("-").map(Number);
  if (!year || !month || !day) return null;
  return new Date(year, month - 1, day);
}

export function formatLocalDate(date) {
  const d = date instanceof Date ? date : parseLocalDate(date);
  if (!d || Number.isNaN(d.getTime())) return "";
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function expandDayRanges(dayRanges) {
  if (!Array.isArray(dayRanges)) return {};
  const days = {};
  for (const range of dayRanges) {
    const { from, to, ...dayData } = range;
    const end = new Date(to);
    let d = new Date(from);
    while (d <= end) {
      const dateStr = formatLocalDate(d);
      days[dateStr] = { ...dayData, date: dateStr };
      d.setDate(d.getDate() + 1);
    }
  }
  return days;
}

export function isSameDay(a, b) {
  if (!a || !b) return false;
  const da = a instanceof Date ? a : new Date(a);
  const db = b instanceof Date ? b : new Date(b);
  return (
    da.getFullYear() === db.getFullYear() &&
    da.getMonth() === db.getMonth() &&
    da.getDate() === db.getDate()
  );
}
